/* eslint-disable react/sort-comp */
/* eslint-disable prefer-destructuring */
import React, { Component } from 'react';
import Select from 'react-select';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import AWS from 'aws-sdk';
/** ******************************************************************
*  Components import
* ***************** */
import moment from 'utils/moment';
import FormSubmitted from '../forms/components/FormSubmitted';
import Step0 from './steps/Step0/Step0';
import Step1 from './steps/Step1/Step1';
import Step2 from './steps/Step2/Step2';
import Button from '../../components/button';
import Loading from '../../components/loading';

import ProgressBar from './components/ProgressBar';
import { GetFileName, S3Uploads } from '../services';
import { isLocal, hostName } from '../../constants/apiEnv';

/** ******************************************************************
*  Assets import
* ************* */
import style from './hazard_create.module.scss';
import styles from './hazard_builder.module.scss';
import SingleForm from './SmsSingleForm';
import DefaultFields from './defaulf_fields.json';
import { importAllImages, getS3Region } from '../../utils/helpers';
import { handleMultiFieldErrorList } from '../forms/utils/helpers';

const url = hostName.slice(6);

class HazardBuilder extends Component {
  firstTime = true;

  priorityOptions = [
    { key: 'low', name: 'Low' },
    { key: 'medium', name: 'Medium' },
    { key: 'high', name: 'High' }
  ];

  constructor(props) {
      super(props);
        this.next = this.next.bind(this);
        this.prev = this.prev.bind(this);
        this.create = this.create.bind(this);
        this.state = {
          requiredMap: {},
          conditionalFields: [],
          answers: {},
          showFormErrors: false,
          currentStep: 0,
          lastIdAdded: 2,
          apiStatus: undefined,
          errors: false,
          singleLocation: false,
          hazardInfo: {
            is_anonymous: false,
            badge_info: false,
            contact_info: true,
            enable_notifications: false,
            report_date: moment().format(),
            attachments: [],
            Polygon: [],
            global_location: {}
          },
          fieldErrors: {
            title: false,
            description: true,
            firstName: true,
            lastName: true,
            phone: true,
            email: true,
            category: true,
            priority: true,
            badge_id: false
          },
          loadingStatus: true,
          captchaError: false,
          successMessage: '',
          fileSizeError: false,
          selectedLang: localStorage.getItem('lang') || false
        };
        this.handleAnswerChanged = this.handleAnswerChanged.bind(this);
        const { match: { params: { id } } } = props;
        localStorage.setItem('portalBackendId', id);
        this.publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${id}${url}/public`;
        this.images=importAllImages(require.context('../../images', false, /\.(png|jpe?g|svg)$/));
  }

  recaptchaRef = React.createRef();

  async componentDidMount() {
    const { match: { params: { airportCode } } } = this.props;
    const { hazardInfo } = this.state;
    fetch(`${this.publicUrl}/safety_management/get_schema/${airportCode}`)
    .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw Error(response.statusText);
      })
    .then((data) => {
      const sms_form = data;
      const airport_data = data.airport;
      const supportMultiLang = sms_form?.public_form_settings?.multi_language_settings;
      const selectedLanguages = sms_form?.public_form_settings?.multi_language_settings?.selectedLanguages;
      if (!localStorage.getItem('lang') && sms_form?.public_form_settings?.multi_language_settings
      ?.support_multiple_languages) {
        localStorage.setItem('lang', (supportMultiLang && selectedLanguages
          && selectedLanguages.length > 0 && (selectedLanguages.length === 1 ? selectedLanguages[0] : sms_form?.public_form_settings?.defaultLang))
          || sms_form?.public_form_settings?.multi_language_settings?.defaultLang || 'en');
          window.location.reload();
      } else if (localStorage.getItem('lang') && selectedLanguages?.length === 1 && localStorage.getItem('lang') !== selectedLanguages[0]) {
        localStorage.setItem('lang', selectedLanguages[0]);
        window.location.reload();
      }
      this.getData(sms_form.public_form_settings?.success_message_attachment);
      this.setState({
        loadingStatus: false,
        airport_data,
        sms_form,
        hazardInfo: {
          ...hazardInfo,
          location: airport_data?.location
        },
        selectedLang: localStorage.getItem('lang') || (supportMultiLang && selectedLanguages
          && selectedLanguages.length > 0 && sms_form?.public_form_settings?.defaultLang)
        || sms_form?.public_form_settings?.multi_language_settings?.defaultLang || ''
      });
    }).catch(() => {
      const message = 'There was a problem while retrieving the form';
      this.setState({
        message,
        apiStatus: true,
        loadingStatus: false
      });
    });
    this.getConfig();
  }


  componentDidUpdate(prevProps) {
    const { sms_form } = this.state;
    if (this.firstTime && sms_form && sms_form.hazard && sms_form.hazard.id && prevProps?.sms_form !== sms_form) {
      this.hazardProcess(sms_form.hazard);
      this.handleErrorsInState(sms_form);
      this.firstTime = false;
    }
  }

  componentWillUnmount() {
    localStorage.removeItem('lang');
  }

  handleErrorsInState = (sms_form) => {
    if (sms_form?.public_form_settings && Object.keys(sms_form?.public_form_settings || {})?.length > 0) {
      this.setState(prev => ({
        ...prev,
        fieldErrors: {
          ...prev.fieldErrors,
          email: !sms_form?.public_form_settings?.email,
          firstName: !sms_form?.public_form_settings?.name,
          lastName: !sms_form?.public_form_settings?.name,
          phone: !sms_form?.public_form_settings?.phone
        }
      }));
    }
  };

  hazardProcess = (hazard) => {
    const { hazardInfo, sms_form } = this.state;
    if (hazard) {
      const { schema } = hazard;
      let conditionalFields = [];
      let errorListMCG = {};
      let { fieldErrors, requiredMap } = this.state;
      const fields = schema?.fields.filter(field => (
        field?.internal !== true
      ));
      fields.forEach((field) => {
        if (field.type !== 'dataSource'
            && field.type !== 'dataSourceMultiselect'
            && field.type !== 'dataSourceMultiLevel'
            && field.type !== 'page_break'
            && field.type !== 'header'
            && field.type !== 'attachments') {
          requiredMap = { ...requiredMap, [field.id]: field.required };
          if (!field.conditional) {
            fieldErrors = {
              ...fieldErrors,
              [field.id]: field.required
            };
          } else {
            conditionalFields.push(field);
          }
        }
        if (field.type === 'multi_field') {
          errorListMCG = handleMultiFieldErrorList(field, [], field.id, {});
        }
      });

      if (sms_form?.public_form_settings?.locations?.length === 1) {
        hazardInfo.global_location = { location: sms_form?.public_form_settings?.locations[0]?.label };
        this.setState({ singleLocation: true });
      } else {
        hazardInfo.global_location = {};
        this.setState({ singleLocation: false });
      }
      this.setState({ requiredMap, fieldErrors, conditionalFields, hazardInfo, errorListMCG });
    }
  };

  handleFieldErrorChanged = (id, value) => {
    this.setState(prevState => ({
      fieldErrors: {
        ...prevState.fieldErrors,
        [id]: value
      }
    }));
  };


  evaluateCategoryCondition = (fieldId, answer, condField) => {
    const { answers } = this.state;
    const triggerMap = {
      category: 'default_category',
      sub_category: 'default_sub_category',
      sub_category_2: 'default_sub_category_2'
    };

    const triggerKey = triggerMap[fieldId];
    if (!triggerKey) return false;

    const conditions = Array.isArray(condField.conditional_values) ? condField.conditional_values : [];

    const conditionMatched = conditions.some((conditionObj) => {
      const values = conditionObj[triggerKey];
      if (!Array.isArray(values)) return false;
      return values.every(v => (answer || []).includes(v));
    });

    const hasAnswer = answers?.[condField.id] || false;

    if (conditionMatched && hasAnswer) {
      return false;
    }

    return conditionMatched;
  };

  handleAnswerChanged = (section, answer, fieldId) => {
    const { fieldErrors, conditionalFields } = this.state;
    const { sms_form: { hazard: { schema: { fields = [] } = {} } = {} } = {} } = this.state;
    const questions=['is_anonymous', 'badge_info', 'contact_info'];
    const categoryConditionalFields = conditionalFields.filter(
      f => f?.conditional_field?.key === 'default_category'
    );
    const fieldType = fields?.find(obj => obj.id === fieldId);

    if (fieldType?.type === 'multi_field' && answer?.length > 0) {
      this.setState((prevState) => {
        const updatedErrorListMCG=handleMultiFieldErrorList(fieldType, answer, fieldId, prevState);
        return { errorListMCG: updatedErrorListMCG };
      });
    }
    if (
      ['category', 'sub_category', 'sub_category_2'].includes(fieldId)
      && categoryConditionalFields.length > 0
    ) {
      this.setState((prevState) => {
        const updatedSection = {
          ...prevState[section],
          [fieldId]: answer
        };

        categoryConditionalFields.forEach((condField) => {
          const isValue = this.evaluateCategoryCondition(
            fieldId,
            answer,
            condField
          );

          this.handleFieldErrorChanged(condField.id, isValue);

          if (!isValue) {
            updatedSection[condField.id] = '';
          }
        });

        return { [section]: updatedSection };
      });
    }
    if (questions?.includes(fieldId) && answer === true) {
       let questionData = questions?.map(q => (
          this.setState(prevState => ({
            [section]: {
              ...prevState[section],
              [q]: q===fieldId
            }
          }))
        ));
        if (fieldId !== 'contact_info') {
          this.setState({
            fieldErrors: {
              ...fieldErrors,
              firstName: false,
              lastName: false,
              phone: false,
              email: false
            }
          });
        }
        return questionData;
    }
    this.setState(prevState => ({
      [section]: {
        ...prevState[section],
        [fieldId]: answer
      }
    }));
    return null;
  };

  getConfig = () => {
    AWS.config.update({
      region: process.env.REACT_APP_REGION
    });
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID
    });
    return AWS.config.credentials.getPromise();
  };

  getData = (fileName) => {
    const { match: { params: { id: code } } } = this.props;
    const s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: getS3Region()
    });

    const params = {
      Bucket: `${process.env.REACT_APP_S3PREFIX}${isLocal? 'local' : code}-attachments/conditions/sms`,
      Key: `${fileName}`,
      ResponseCacheControl: 'no-cache'
    };

    new Promise((resolve, reject) => {
      s3.getObject(params, (err, data) => {
        if (err) {
          return reject(err);
        }
        return resolve(data);
      });
    }).then((response) => {
      const info = response.Body.toString();
      this.setState({ successMessage: info });
    }).catch(() => {
      this.setState({ successMessage: '' });
    });
  };

  handleUploadAttachments = async (attachments, entity, airportCode) => {
    const attachmentIds = [];
    const newAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      }
    });
    let fileIds = '';
    if (newAttachments?.length > 0) {
      fileIds = await this.getFileNames(newAttachments?.length, airportCode);
    }
    if (fileIds) {
      await this.doS3Upload(newAttachments, fileIds, entity || 'hazard').then(() => {
        fileIds.filename.forEach((attachmentId) => {
          attachmentIds.push(String(attachmentId));
        });
      });
    }

    return attachmentIds;
  }

  handleFileSizeValidation = (val) => {
    this.setState({ fileSizeError: val });
  }

  validateMultiFields = (multiFields, answers = {}) => multiFields.every((field) => {
    const fieldId = field.id;
    const rows = answers[fieldId];

    if (field?.conditional && !this.isConditionSatisfied(field, answers)) {
      return true; // Skip validation if the condition is not satisfied
    }

    const mandatoryKeys = Object.keys(field.multiple_fields || {}).filter(
      key => field.multiple_fields[key]?.mandatory_multi_field
    );

    if (!mandatoryKeys.length) return true;

    if (!Array.isArray(rows) || rows.length === 0) {
      return false;
    }

    return rows.every(row => mandatoryKeys.every((key) => {
      const value = row?.[key];
      return value !== undefined && value !== null && value !== '';
    }));
  });

  isConditionSatisfied = (field, answers) => {
    const condition = field?.conditional_field?.key;
    const conditionValues = field?.conditional_values || [];
    const answer = answers?.[condition];

    if (!condition || !conditionValues.length) {
      return true;
    }

    return conditionValues.every(value => answer?.includes(value));
  };

  create = async () => {
    const { answers, hazardInfo, fieldErrors, sms_form, errorListMCG } = this.state;
    const { match: { params: { airportCode } } } = this.props;
    const global_locations = sms_form?.public_form_settings?.global_locations ?? false;
    const location_sms = sms_form?.public_form_settings?.enable_location_sms ?? false;

    const hasSubCategory = sms_form?.categories?.some(
      c => hazardInfo?.category?.includes(c?.name) && c?.sub_category?.length > 0
    );
    if (!hazardInfo.sub_category || hazardInfo.sub_category.length === 0) {
      if (!sms_form?.public_form_settings?.enable_internal_category) {
        fieldErrors.sub_category = hasSubCategory || false;
      }
    }
   const sub2 = sms_form?.categories?.find(item => hazardInfo?.category?.includes(item?.name))
    ?.sub_category?.find(item => hazardInfo?.sub_category?.includes(item?.name))
    ?.sub_category_2?.map(sub => sub?.name) ?? [];

    if (sms_form?.public_form_settings?.enable_third_level
        && (!hazardInfo.sub_category_2 || hazardInfo.sub_category_2.length === 0) && sub2.length > 0) {
        fieldErrors.sub_category_2 = true;
    } else if (!sub2?.length) {
        fieldErrors.sub_category_2 = false;
    }
     if (!sms_form?.public_form_settings?.enable_internal_category) {
        if (!hazardInfo.category || hazardInfo.category.length === 0) {
            fieldErrors.category = true;
        }
        if (!hazardInfo.priority) {
            fieldErrors.priority = true;
        }
    }

    if (sms_form.public_form_settings?.enable_internal_category) {
      fieldErrors.category = !sms_form.public_form_settings?.enable_internal_category;
      fieldErrors.priority = !sms_form.public_form_settings?.enable_internal_category;
    }
    let noErrors = Object.keys(fieldErrors).every(
      k => fieldErrors[k] === false
      );
    if (sms_form.public_form_settings?.enable_captcha) {
      const recaptchaValue = this.recaptchaRef.current?.getValue();
      if (!recaptchaValue || recaptchaValue?.length === 0) {
        noErrors = false;
        this.setState({ captchaError: true });
      }
    }
    const hazardSchemaFields = sms_form?.hazard?.schema?.fields || [];

    const multiColFieds = hazardSchemaFields.filter(field => field?.type === 'multi_field') || [];
    if (multiColFieds?.length && !this.validateMultiFields(multiColFieds, answers)) {
      this.setState({ showFormErrors: true });
      return;
    }

    if (Object.keys(errorListMCG).length > 0) {
      this.setState({ showFormErrors: true });
      return;
    }

    if (noErrors) {
      this.setState({ loadingStatus: true });
      const data = {
        user_access_type: {
          is_anonymous: hazardInfo.is_anonymous,
          badge_info: hazardInfo.badge_info,
          contact_info: hazardInfo.contact_info,
          enable_notifications: hazardInfo?.contact_info ? hazardInfo?.enable_notifications : false
        },
        title: hazardInfo.title,
        report_date: moment(hazardInfo.report_date).format('YYYY-MM-DD'),
        report_time: moment(hazardInfo.report_time).format('HH:mm'),
        reported_date: `${moment(hazardInfo.report_date).format('YYYY-MM-DD')} ${moment(hazardInfo.report_time).format('HH:mm:ssZ')}`,
        category: hazardInfo.category?.map(cat => cat)?.join('$$'),
        sub_category: hazardInfo.sub_category?.map(subcat => subcat)?.join('$$'),
        sub_category_2: hazardInfo.sub_category_2?.map(subcat1 => subcat1)?.join('$$'),
        priority: !sms_form.public_form_settings?.enable_internal_category ? hazardInfo.priority : '',
        description: hazardInfo.description,
        response: { ...answers },
        attachments: [],
        Polygon: hazardInfo?.Polygon?.length > 0 ? [hazardInfo.Polygon] : undefined
      };

      const attachmentFields = sms_form?.hazard?.schema?.fields?.filter(schemaField => (
        schemaField?.type === 'attachments'));
      if (attachmentFields?.length > 0) {
        // eslint-disable-next-line no-restricted-syntax
        for (const { id: attachmentField, type } of attachmentFields) {
          if (type === 'attachments' && data.response[attachmentField]?.length > 0) {
            // eslint-disable-next-line no-await-in-loop
            data.response[attachmentField] = await this.handleUploadAttachments(data.response[attachmentField], 'hazard', airportCode);
          }
        }
      }

      if ((global_locations && location_sms)
        && hazardInfo?.global_location && hazardInfo?.selected_map === 'indoor') {
        data.global_location = hazardInfo?.global_location;
        data.global_location.location_marked = hazardInfo?.location_marked;
        data.global_location.location_attachment = hazardInfo?.location_attachment;
      } else if ((global_locations && location_sms) && hazardInfo?.selected_map === 'airfield') {
        data.location = {
          type: 'Point',
          coordinates: hazardInfo.location
        };
      } else if (!location_sms) {
        data.location = {
          type: 'Point',
          coordinates: hazardInfo.location
        };
      } else if ((global_locations && location_sms)) {
        data.global_location = hazardInfo?.global_location;
      }

      if (hazardInfo?.contact_info) {
        data.reported_by = {
          first_name: hazardInfo.firstName,
          last_name: hazardInfo.lastName,
          email: hazardInfo.email,
          company: hazardInfo.companyName,
          phone: hazardInfo.phone
        };
      }
      if (hazardInfo?.badge_info) {
        data.user_access_type.badge_number = hazardInfo?.badge_id;
      }
      const newAttachments = [];
      if (hazardInfo.attachments && hazardInfo.attachments.length > 0) {
          hazardInfo.attachments.forEach((e) => {
          if (!e.id) {
              newAttachments.push(e);
          }
        });
      }
      let fileIds = '';
      if (newAttachments.length > 0) {
        fileIds = await this.getFileNames(newAttachments.length, airportCode);
      }
      if (fileIds) {
        await this.doS3Upload(newAttachments, fileIds, 'hazard').then(() => {
          fileIds.filename.forEach((attachmentId) => {
            data.attachments.push(attachmentId.toString());
          });
        });
        data.airportCode = this.props.match.params.airportCode;
      }
      if (
        'removedAttachments' in hazardInfo
        && hazardInfo?.removedAttachments?.length > 0
      ) {
        data.removedAttachments = hazardInfo.removedAttachments;
      } else {
        try {
          await fetch(`${this.publicUrl}/safety_management/create_sms_hazard/${airportCode}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' }
          })
          .then(response => response.json())
          .then(() => {
            this.setState({
              message: 'Your report has been submitted successfully.A staff member from the Airport safety team will be reaching out to you soon.',
              apiStatus: true,
              loadingStatus: false
            });
          });
        } catch (error) {
          let message = 'There was a problem while submitting the form';
          if (error && error.detail) message = error.detail;
          this.setState({
            message,
            apiStatus: true,
            loadingStatus: false
          });
        }
      }
      } else {
        this.setState({ showFormErrors: true });
      }
  };

  getFileNames = async (count, airportCode) => {
    const response = await GetFileName.getPublicUploadFileName(count, airportCode);
    return response;
  };

  doS3Upload = async (files, fileIds, entity) => {
    const { match } = this.props;
    const installation = match.params.id;
    const airportCode = match.params.airportCode;
    const response = await S3Uploads.uploadFiles(
        files,
        fileIds.filename,
        entity,
        installation,
        airportCode
    );
    return response;
  };

  next() {
    const { currentStep, fieldErrors, hazardInfo, sms_form } = this.state;
    const {
        user,
        match: {
        params: { id }
        }
    } = this.props;

    let noErrors = true;

    const dataSchema = sms_form?.hazard?.schema?.fields?.filter(field => (
      field.type!=='dataSource'
      && field.type!=='dataSourceMultiselect'
      && field?.internal !== true
    ));

    const customFields = dataSchema?.map(order => order.id) || [];
    let fieldsOrdering = DefaultFields.default_fields.map(order => order.id);
    if (customFields?.length > 0) fieldsOrdering = [...fieldsOrdering, ...customFields];
    if (sms_form?.hazard?.schema?.ordering?.length > 0) {
      fieldsOrdering = sms_form.hazard?.schema?.ordering;
    }

    if (currentStep === 1) {
      if (fieldsOrdering?.length > 0) {
        const stepOneErrors = fieldsOrdering.filter(orderId => (fieldsOrdering.indexOf('default_step2') > fieldsOrdering.indexOf(orderId)));
        if (stepOneErrors.indexOf('default_reported_by') !== -1) stepOneErrors.push('firstName', 'lastName', 'email', 'phone');
        stepOneErrors.forEach((k) => {
          const field = k.replace('default_', '');
          if (field in fieldErrors && fieldErrors[field] === true) {
            noErrors = false;
          }
        });
        if (hazardInfo?.badge_info && !hazardInfo.badge_id) {
          noErrors = false;
        }
      }
    }
    if (currentStep === 2) {
        if (fieldErrors.title === true) {
            noErrors = false;
        }
    }

    if (currentStep === 0 && !id) {
        if (hazardInfo.is_anonymous === false) {
          const data = hazardInfo;
          data.firstName = user.first_name;
          data.lastName = user.last_name;
          data.email = user.user.email;
          data.phone = user.phone;
          this.setState({
            hazardInfo: data
          });
        }
    }
    if (noErrors) {
        this.setState(prevState => ({
          currentStep: Math.min(2, prevState.currentStep + 1),
          showFormErrors: false
        }));
        if (currentStep === 3) {
          this.setState({ id: undefined });
        }
    } else {
      this.setState({ showFormErrors: true });
    }
  }

  prev() {
    this.setState(
      (prevState) => {
      let newState = {
          currentStep: Math.max(0, prevState.currentStep - 1)
      };
      if (prevState.currentStep === 1) {
          newState = {
          ...newState
          };
      }
      return newState;
      }
    );
  }

  handleLogo = () => {
    const { sms_form, airport_data } = this.state;
    let logoImg;
    if (sms_form?.public_form_settings?.custom_logo && sms_form?.custom_logo_attachement?.length) {
      logoImg = (sms_form?.custom_logo_attachement[0]?.image || sms_form?.custom_logo_attachement[0]?.url);
    } else if (airport_data?.image) {
      logoImg = airport_data?.image;
    }
    return logoImg;
  }

  getLanguageSelect = () => {
    const { selectedLang, sms_form, apiStatus } = this.state;
    const lang = [{ label: 'English', value: 'en' },
      { label: 'Spanish', value: 'es', image: this.images['spainFlag.png'] },
      { label: 'French', value: 'fr', image: this.images['franceFlag.png'] }, { label: 'German', value: 'de', image: this.images['germanFlag.png'] },
      { label: 'Portuguese', value: 'pt', image: this.images['portugalFlag.png'] },
      { label: 'Azerbaijani', value: 'az', image: this.images['Flag_of_Azerbaijan.svg'] },
      { label: 'Russian', value: 'ru', image: this.images['russianFlag.png'] }];
      const selectedLanguages = sms_form?.public_form_settings?.multi_language_settings?.selectedLanguages;
      const supportMuliLang =sms_form?.public_form_settings?.multi_language_settings?.support_multiple_languages;
    return (
      <>
      {!apiStatus && supportMuliLang && selectedLanguages && selectedLanguages.length>0 && (selectedLang || selectedLang === '')
        && <div className={styles.languageContainer}>
            <Select
              className={styles.languageSelect}
              classNamePrefix="select"
              defaultValue={(selectedLang && selectedLang!==''
              && lang.filter(item => item?.value === selectedLang)[0]) ?? { label: 'English', value: 'en' }}
              name="color"
              getOptionLabel={e => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {e.image && <img src={e.image.default} alt="flag" className={styles.flagStyles} />}
                  {e.label}
                </div>
              )}
              onChange={(e) => {
                localStorage.setItem('lang', e?.value);
                window.location.reload();
              }}
              options={selectedLanguages && selectedLanguages.length > 0
                ? lang?.filter(language => (selectedLanguages.findIndex(item => item===language?.value) !== -1))
                : lang}
                />
           </div>
      }
      </>
  );
}

render() {
  const {
    currentStep,
    hazardInfo,
    apiStatus,
    showFormErrors,
    requiredMap,
    answers,
    loadingStatus,
    sms_form,
    airport_data,
    message,
    captchaError,
    successMessage,
    singleLocation,
    fileSizeError,
    selectedLang,
    errorListMCG
  } = this.state;
  const { intl } = this.props;

  const dataSchema = sms_form?.hazard?.schema?.fields?.filter(field => (
    field.type!=='dataSource'
    && field.type!=='dataSourceMultiselect'
    && field?.internal !== true
  ));
  const customFields = dataSchema?.map(order => order.id) || [];
  let fieldsOrdering = DefaultFields.default_fields.map(order => order.id);
  if (customFields?.length > 0) fieldsOrdering = [...fieldsOrdering, ...customFields];
  if (sms_form?.hazard?.schema?.ordering?.length > 0) {
    fieldsOrdering = sms_form.hazard?.schema?.ordering;
  }
   const hasDefaultHeader = fieldsOrdering?.includes('default_step2_header');
    if (!hasDefaultHeader) {
      const titleIndex = fieldsOrdering?.findIndex(i => i === 'default_title');
      if (titleIndex !== -1) {
        fieldsOrdering.splice(titleIndex, 0, 'default_step2_header');
      }
    }
  const smsValues = {
    activity_title: 'Comments',
    correctiveaction_title: 'Mitigations',
    hazard_title: 'Safety Hazard',
    riskacceptance_title: 'Risk Acceptance',
    subhazard_title: 'Sub-Hazard'
  };
  const nomenclature = sms_form?.public_form_settings?.nomenclature || smsValues;
  const formTitle = sms_form?.public_form_settings?.form_title || '';
  const anonymousSetting = sms_form?.public_form_settings?.enable_anonymous_check ?? true;
  const enableBadge = sms_form?.public_form_settings?.enable_badge ?? true;

  let location_value = [];

  if ((sms_form?.public_form_settings?.global_locations && sms_form?.public_form_settings?.enable_location_sms)
      && sms_form?.sms_locations?.length > 0) {
    location_value = sms_form?.sms_locations;
  } else if ((sms_form?.public_form_settings?.global_locations && sms_form?.public_form_settings?.enable_location_sms)
      && sms_form?.sms_locations?.length === 0) {
    location_value = sms_form?.global_locations;
  }
return (
  <div style={{ color: selectedLang==='az' ? '#2e406b' : '',
                fontFamily: selectedLang==='az' ? 'calibri' : '',
                fontWeight: selectedLang==='az' ? 'bold' : '' }}>
    <div className={styles.Image}>
    {this.handleLogo() ? <img src={this.handleLogo()} alt="airport_logo" /> : ''}
    </div>
    {loadingStatus && (
      <Loading loadingStatus={loadingStatus} />
    )}
    <div className={styles.container}>
      {!apiStatus && sms_form?.public_form_settings?.display_single_form && (
        <SingleForm
          handleAnswerChanged={this.handleAnswerChanged}
          hazardInfo={hazardInfo}
          handleFieldErrorChanged={this.handleFieldErrorChanged}
          showFormErrors={showFormErrors}
          priorityOptions={sms_form?.sms_priorities?.[0]?.priority?.length > 0 ? sms_form?.sms_priorities[0]?.priority
            : this.priorityOptions || []}
          sms_form={sms_form}
          airport_data={airport_data}
          requiredMap={requiredMap}
          answers={answers}
          create={this.create}
          fieldsOrdering={fieldsOrdering}
          dataSchema={dataSchema || []}
          captchaError={captchaError}
          recaptchaRef={this.recaptchaRef}
          defaultFieldSchema={sms_form?.hazard?.schema?.default_fields || {}}
          nomenclature={nomenclature}
          smsFormTitle={formTitle}
          categorySetting={sms_form?.public_form_settings?.enable_internal_category || false}
          singleLocation={singleLocation}
          enableBadge={enableBadge}
          location_value={location_value}
          fileSizeError={fileSizeError}
          handleFileSizeValidation={this.handleFileSizeValidation}
          datasources={sms_form?.hazard?.global_data_source}
          selectedLang={selectedLang}
          getLanguageSelect={this.getLanguageSelect}
          errorListMCG={errorListMCG}
          anonymousSetting={anonymousSetting}
        />
      )}
      {!sms_form?.public_form_settings?.display_single_form
        && !apiStatus && sms_form
        && Object.keys(sms_form).length > 0 && (
        <div className={styles.box}
          style={{ background: selectedLang === 'az' ? '#e7eaef' : '', fontFamily: selectedLang === 'az' ? 'calibri' : '' }}>
          <div className={styles.title} style={{ borderBottom: selectedLang === 'az' ? '1px solid #2e406b' : '1px solid #E6EAEE' }}>
              {currentStep !== 0 && (
                <FormattedMessage
                id={formTitle || 'sms.new.newHazard'}
                values={{ title: formTitle || intl.formatMessage({ id: `sms.nomenclature.${nomenclature?.hazard_title?.replace(/\s+/g, '')}`,
                  defaultMessage: nomenclature?.hazard_title || 'Safety Hazard' }) }}
                defaultMessage={formTitle || `${nomenclature?.hazard_title} Report Form `}
                />
              )}
            {sms_form?.public_form_settings?.multi_language_settings?.selectedLanguages?.length > 1
            && this.getLanguageSelect()
            }
          </div>
          <div className={styles.content}>
            {currentStep !== 0 && currentStep !== 3 && (
              <ProgressBar step={currentStep} />
            )}
            {currentStep === 0 && (
              <Step0
              goToNext={this.next}
              onUserCheck={this.handleAnswerChanged}
              info={hazardInfo}
              enableBadge={enableBadge}
              anonymousSetting={anonymousSetting}
              />
            )}
            <div className={`${styles.details_form} ${hazardInfo?.is_anonymous ? styles.reportInfoStyle : ''}`}>
              {fieldsOrdering?.map(field => (
                <>
                  {fieldsOrdering.indexOf('default_step2') > fieldsOrdering.indexOf(field) && currentStep === 1 && (
                    <>
                      <Step1
                        onInfoChange={(a, b) => this.handleAnswerChanged('hazardInfo', b, a)}
                        info={hazardInfo}
                        handleFieldErrorChanged={this.handleFieldErrorChanged}
                        showFormErrors={showFormErrors}
                        orderField={field}
                        defaultFieldSchema={sms_form?.hazard?.schema?.default_fields || {}}
                        enableBadge={enableBadge}
                        dataSchemaValue={sms_form?.public_form_settings}
                        selectedLang={selectedLang}
                        airport_data={airport_data}
                      />
                      <Step2
                        hazardInfo={hazardInfo}
                        category={sms_form?.categories || []}
                        priority={sms_form?.sms_priorities?.[0]?.priority?.length > 0 ? sms_form?.sms_priorities[0]?.priority
                          : this.priorityOptions || []}
                        onInfoChange={(a, b) => this.handleAnswerChanged('hazardInfo', b, a)}
                        handleAnswerChanged={(a, b) => this.handleAnswerChanged('answers', a, b)}
                        handleFieldErrorChanged={this.handleFieldErrorChanged}
                        showFormErrors={showFormErrors}
                        dataSchema={dataSchema}
                        map={airport_data}
                        requiredMap={requiredMap}
                        answers={answers}
                        orderField={field}
                        defaultFieldSchema={sms_form?.hazard?.schema?.default_fields || {}}
                        nomenclature={nomenclature}
                        locationList={location_value}
                        categorySetting={sms_form?.public_form_settings?.enable_internal_category || false}
                        singleLocation={singleLocation}
                        publicFormSettings={sms_form?.public_form_settings}
                        fileSizeError={fileSizeError}
                        handleFileSizeValidation={this.handleFileSizeValidation}
                        datasources={sms_form?.hazard?.global_data_source}
                        selectedLang={selectedLang}
                        sms_form={sms_form}
                        errorListMCG={errorListMCG}
                      />
                    </>
                  )}
                  {fieldsOrdering.indexOf('default_step2') < fieldsOrdering.indexOf(field) && currentStep === 2 && (
                    <>
                      <Step1
                        onInfoChange={(a, b) => this.handleAnswerChanged('hazardInfo', b, a)}
                        info={hazardInfo}
                        handleFieldErrorChanged={this.handleFieldErrorChanged}
                        showFormErrors={showFormErrors}
                        orderField={field}
                        defaultFieldSchema={sms_form?.hazard?.schema?.default_fields || {}}
                        enableBadge={enableBadge}
                        selectedLang={selectedLang}
                      />
                      <Step2
                        hazardInfo={hazardInfo}
                        category={sms_form?.categories || []}
                        priority={sms_form?.sms_priorities?.[0]?.priority?.length > 0 ? sms_form?.sms_priorities[0]?.priority
                          : this.priorityOptions || []}
                        onInfoChange={(a, b) => this.handleAnswerChanged('hazardInfo', b, a)}
                        handleAnswerChanged={(a, b) => this.handleAnswerChanged('answers', a, b)}
                        handleFieldErrorChanged={this.handleFieldErrorChanged}
                        showFormErrors={showFormErrors}
                        dataSchema={dataSchema}
                        map={airport_data}
                        requiredMap={requiredMap}
                        answers={answers}
                        orderField={field}
                        defaultFieldSchema={sms_form?.hazard?.schema?.default_fields || {}}
                        nomenclature={nomenclature}
                        locationList={location_value}
                        categorySetting={sms_form?.public_form_settings?.enable_internal_category || false}
                        singleLocation={singleLocation}
                        publicFormSettings={sms_form?.public_form_settings}
                        fileSizeError={fileSizeError}
                        handleFileSizeValidation={this.handleFileSizeValidation}
                        datasources={sms_form?.hazard?.global_data_source}
                        selectedLang={selectedLang}
                        sms_form={sms_form}
                        errorListMCG={errorListMCG}
                      />
                    </>
                  )}
                </>
              ))}
            </div>
            {currentStep === 2 && sms_form.public_form_settings?.enable_captcha && (
                <>
                  <ReCAPTCHA
                    ref={this.recaptchaRef}
                    sitekey={process.env.REACT_APP_RECAPTCHA_TOKEN}
                    hl={selectedLang}
                  />
                  {captchaError && (
                    <div className={style.captchaError}>
                      <FormattedMessage id="sms.form.captcha_error" defaultMessage="Captcha is not Checked" />
                    </div>
                  )}
                </>
              )}
          </div>
          {currentStep !== 0 && currentStep !== 3 && (
            <div className={styles.footer} style={{ borderTop: selectedLang === 'az' ? '1px solid #2e406b' : '1px solid #E6EAEE' }}>
                <Button
                  action="tertiary"
                  onClick={this.prev}
                  translationID="inspections.new.prev"
                  defaultText="Back"
                  className={selectedLang === 'az' ? styles.borderStyle : ''}
                />
              {currentStep !== 2 && (
              <Button
                action="secondary"
                onClick={this.next}
                translationID="hazards.new.nexts"
                defaultText="Continue to Next Step"
              />
              )}
              {currentStep === 2 && (
                <div className={styles.saveBtns}>
                  <div className={`${style.footer} ${style.embedded}`}>
                    <div className={style.errors} />
                    <Button
                      action="secondary"
                      onClick={() => this.create()}
                      translationID={selectedLang === 'az' ? 'Yarat' : 'inspections.new.create'}
                      defaultText={selectedLang === 'az' ? 'Yarat' : 'Create'}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
    )}
    {apiStatus && (
      <div className={`${styles.container} ${styles.formSubmitContainer}`}>
        <FormSubmitted name=""
          message={message} logo={sms_form?.airport_data?.image}
          successMessage={successMessage}
          submitAnotherEntry
        />
      </div>
    )}
    <span className={styles.Link}>
      <a href="https://www.aerosimple.com" target="_blank" rel="noopener noreferrer">
        <FormattedMessage
          id="sms.hazard.poweredBy"
          defaultMessage="Powered by Aerosimple" />
      </a>
    </span>
    </div>
  </div>
);
}
}

HazardBuilder.propTypes = {
  history: PropTypes.shape({}).isRequired
};

export default injectIntl(HazardBuilder);
